import { render, staticRenderFns } from "./PlaceList.vue?vue&type=template&id=6abb41fc&scoped=true&"
import script from "./PlaceList.vue?vue&type=script&lang=js&"
export * from "./PlaceList.vue?vue&type=script&lang=js&"
import style0 from "./PlaceList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PlaceList.vue?vue&type=style&index=1&id=6abb41fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb41fc",
  null
  
)

export default component.exports